import { render, staticRenderFns } from "./PendingPacking.vue?vue&type=template&id=66a42ef8&"
import script from "./PendingPacking.vue?vue&type=script&lang=js&"
export * from "./PendingPacking.vue?vue&type=script&lang=js&"
import style0 from "./PendingPacking.vue?vue&type=style&index=0&id=66a42ef8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports